import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-surveys',
  template: require('./surveys.component.html')
})
export class SurveysComponent extends BaseComponent implements OnInit {

  public surveys = [];

  ngOnInit() {
    this.loadSurveys();
  }

  public preview(surveyId, isManager) {
    this.busy = this.lsApi.generateSurveyPreview(surveyId, isManager).subscribe(resp => {
      if(resp.status) {
        var url = resp.data[0];
        bootbox.confirm({
          message: "Below is the link for the preview.<br><br><b>Link:</b> https://leadershipmatters.briviaconsulting.com" + url,
          buttons: {
              confirm: {
                  label: 'Open Preview',
                  className: 'btn-primary'
              },
              cancel: {
                  label: 'Close',
                  className: 'btn-default'
              }
          },
          callback: function (result) {
            if(result)
              window.open(url);
          }
      });
          //this.surveys = resp.data;
          //this.router.navigate([this.router.url]);
      }
  },
  error => {
      console.log(error);
  });
  }

  public loadSurveys() {
    this.busy = this.lsApi.getSurveys().subscribe(resp => {
        if(resp.status) {
            this.surveys = resp.data;
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public duplicateSurvey(survey) {

    bootbox.confirm({message:"Do you want to duplicate " + survey.title + " survey and all it's question data?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {


          this.busy = this.lsApi.duplicateSurveybyId(survey.surveyId).subscribe(resp => {
            if(resp.status) {
              this.appToast.success("Survey successfully duplicated","Survey Duplicated");
              this.loadSurveys();
            }
          },
          error => {
            bootbox.alert(error);
          });

          
        }
      }});
    
  }

  public deleteSurvey(org) {
    
    bootbox.confirm({message:"Do you want to delete this survey and all it's data including survey questions?<br><small>All the survey and it's data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {


          this.busy = this.lsApi.deleteSurveyById(org.surveyId).subscribe(resp => {
            if(resp.status) {
              this.appToast.success("Survey successfully deleted","Survey Deleted");
              this.loadSurveys();
            }
          },
          error => {
            bootbox.alert(error);
          });

          
        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/surveys/surveys.component.ts